import { render } from "./atmLogo.vue?vue&type=template&id=0f0016e3"
import script from "./atmLogo.vue?vue&type=script&lang=js"
export * from "./atmLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__